
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 34","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.501 31.329l-9.403-9.387c4.218-5.282 3.885-13.023-1.013-17.898C17.824-1.207 9.267-1.207 4.006 4.03 1.466 6.58.06 9.96.06 13.552c0 3.591 1.406 6.972 3.946 9.522a13.402 13.402 0 009.54 3.939c3.099 0 6.032-1.041 8.405-2.943l9.403 9.387c.303.301.68.437 1.074.437.393 0 .77-.15 1.073-.437a1.5 1.5 0 000-2.128zM6.153 20.946a10.37 10.37 0 01-3.069-7.38c0-2.791 1.088-5.417 3.069-7.379a10.424 10.424 0 017.393-3.048c2.675 0 5.351 1.011 7.392 3.048 4.082 4.075 4.082 10.7 0 14.774a10.407 10.407 0 01-7.392 3.064c-2.797-.03-5.428-1.117-7.393-3.079z"}}),_c('path',{attrs:{"d":"M7.105 10.684a.69.69 0 01-.332-.09.674.674 0 01-.272-.92 8.158 8.158 0 011.36-1.797 8.006 8.006 0 013.341-2.007.676.676 0 01.847.453.674.674 0 01-.454.845 6.72 6.72 0 00-2.781 1.66 6.326 6.326 0 00-1.119 1.494.689.689 0 01-.59.362z"}})])
          )
        }
      }
    